/** Türkçe sözlük: bütün ad alanları. */
import { ortak } from "./ortak";
import { bicim } from "./bicim";
import { ui } from "./ui";
import { kabuk } from "./kabuk";
import { rapor } from "./rapor";
import { yedek } from "./yedek";
import { kilit } from "./kilit";
import { donemsel } from "./donemsel";
import { grafik } from "./grafik";
import { iceAktar } from "./iceAktar";
import { ayarlar } from "./ayarlar";
import { sanal } from "./sanal";
import { hesaplar } from "./hesaplar";
import { anaSayfa } from "./anaSayfa";
import { izleme } from "./izleme";
import { hareketler } from "./hareketler";
import { motor } from "./motor";
import { formul } from "./formul";

export const tr = {
  ortak,
  bicim,
  ui,
  kabuk,
  rapor,
  yedek,
  kilit,
  donemsel,
  grafik,
  iceAktar,
  ayarlar,
  sanal,
  hesaplar,
  anaSayfa,
  izleme,
  hareketler,
  motor,
  formul,
};
